import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=031f232c&scoped=true&"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=031f232c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f232c",
  null
  
)

export default component.exports